import React, {useContext, useState} from 'react';
import styled from 'styled-components';

import Link from 'next/link';

import Modal from '../../ui/Modal';
import ModalCart from '../ModalCart';
import { CartContext } from '@/store/context/cart';
import { beautyPrice } from '@/helpers/ost';
import useDeviceDetect from '../../helpers/hooks';
import MenuWarningInfo from './MenuWarningInfo';
import {getCartSum} from "@/services/cart.service";
import Image from 'next/image';

const LogoImage = '/img/icons/logo.png';
const CartIcon = '/img/icons/cart.png';

export default function MenuLine({
  isOrder
}:{
  isOrder?: boolean
}){
  const [openCart, setOpenCart] = useState(false);
  const { cart } = useContext(CartContext);
  const cartSum = getCartSum(cart);

  const { isMobile } = useDeviceDetect();

  return <Container>
    <div className="maxwidth">
      <Link href="/"><Logo>
        <Image
            src={LogoImage}
            alt="Интернет-заказ Таттехмедфарм"
            width={76} height={82}
            priority
        />
        <p>
          Интернет-Заказ<br />
          <span>Таттехмедфарм</span>
        </p>
      </Logo></Link>

      <MenuWarningInfo />

      {!isOrder && <Cart onClick={() => setOpenCart(true)}>
        <CartImage>
          <Image src={CartIcon} alt="" width={31} height={28} />
          <span id="cart-counter">{cart.length}</span>
        </CartImage>

        {!isMobile && <p>
          Корзина<br />
          <span>от {beautyPrice(cartSum)} руб</span>
        </p>}
      </Cart>}
    </div>

    {openCart && <Modal position="right-bottom">
      <ModalCart onClose={() => setOpenCart(false)} />
    </Modal>}
  </Container>
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  border-bottom: 1px solid #eee;
  padding: 5px 0;

  & > div {
    justify-content: space-between;
    display: flex;
    align-items: center;
  }

  @media (max-width: 750px) {
    position: relative;
  }

`

const Logo = styled.div`
  display: flex;
  align-items: center;
  & p {
    text-transform: uppercase;
    font-size: 18.5px;
    letter-spacing: 0.08em;
    color: #9c8450;
  }
  & span {
    color: var(--green);
    font-size: 21px;
    font-family: var(--font-medium);
    letter-spacing: 0.01em;
  }
  & img {
    height: 60px;
    width: auto; 
    margin-right: 10px;
  }
  &:hover {
    cursor: pointer;
  }
  @media (max-width: 480px) {
    & p {
      font-size: 12px;
    }
    & span {
      font-size: 14px;
    }
    & img {
      height: 40px; 
    }
  }
`


const Cart = styled.a`
  display: flex;
  align-items: center;
  min-width: 125px;

  & p span {
    color: var(--red);
  }

  @media (max-width: 480px) {
    min-width: initial;
    position: fixed;
    top: 12px;
    right: 60px;
    z-index: 1000;
  }
`

const CartImage = styled.div`
  position: relative;
  margin-right: 10px;

  & span {
    color: #fff;
    background-color: var(--red);
    border-radius: 50%;
    padding: 2px 5px;
    display: block;
    position: absolute;
    top: -10px;
    right: -10px;
    min-width: 20px;
    text-align: center;
  }

  & img {
    width: 34px;
    height: auto;
  }

  @media (max-width: 480px) {
    & img {
      width: 27px;
    }
  }
`
